import { environment } from './../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MultiBeadChipProcessStepChemicalsDTO, MultiPlateProcessStepChemicalsDTO, ProcessStepChemicalsDTO } from './chemicals-dto'
import { BBResponseContainer } from '../carrier/response-container';
import { Plate } from '../models/plate';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class MaChemicalsPopupService {
  PLATE_PREPARATION_API = environment.BB_SAMPLE_PROCESSING_API
  NGS_SAMPLES_API = environment.BB_APG_SAMPLE_PROCESSING_URL

  constructor(private httpClient: HttpClient) { }

  updateChemicalForNGS(chemicalDTO: ProcessStepChemicalsDTO, labId: string, batchId: string){
    let url = this.NGS_SAMPLES_API+'covid19Batch/updateProcessStepChemicals/'+batchId+"?labId="+labId;
    return this.httpClient.post<BBResponseContainer>(url, chemicalDTO);
  }

  updateChemical(chemicalDTO: ProcessStepChemicalsDTO, labid: string, plateid: string){
    let url = this.PLATE_PREPARATION_API+'updatePlateChemicals/'+ labid + '/' +plateid;
    return this.httpClient.put<BBResponseContainer>(url,chemicalDTO).pipe(map(result => result.data as Plate))
  }

  updateBeadChipChemical(chemicalDTO: ProcessStepChemicalsDTO, labid: string, plateid: string, beadchipid){
    let url = this.PLATE_PREPARATION_API+'updateBeadChipChemicals/'+ labid + '/' +plateid + '/'+ beadchipid;
    return this.httpClient.put<any>(url,chemicalDTO);
  }

  updateMultiPlateChemical(chemicalDTO: MultiPlateProcessStepChemicalsDTO){
    let url = this.PLATE_PREPARATION_API+'updateMultiplePlateChemicals';
    return this.httpClient.put<any>(url,chemicalDTO);
  }

  updateMultiBeadChipChemical(chemicalDTO: MultiBeadChipProcessStepChemicalsDTO){
    let url = this.PLATE_PREPARATION_API+'updateMultipleBeadChipChemicals';
    return this.httpClient.put<any>(url,chemicalDTO);
  }
}
